import React from "react";
import { graphql, Link } from "gatsby";
import RichText from "../components/richText";
import Layout from 'components/layout';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import Fade from "react-reveal/Fade";
import Pill from "../vectors/pill";
import SEO from "react-seo-component";/* 
import QAComponent from "../components/QAComponent"; */
import DotGrid from "../images/dot-grid.png";
import MobilePng from "../images/mobile_phone.jpg";
import DotGridPurple from "../images/dot-grid-purple.png";
import arrowDown from "../images/arrow-down.png";
import wavyLines from "../images/wavy-lines.png";
import linedFloater from "../images/lined-floater.png";
import FlourishLineLeft from "../images/flourish-lines-left.png";
import FlourishLineRight from "../images/flourish-lines-right.png";

const responsive = {
  desktop: {
    breakpoint: { max: 4000, min: 900 },
    items: 3,
  },
  mobile: {
    breakpoint: { max: 899, min: 0 },
    items: 1,
  },
};

const Index = (props) => {
  const doc = props.data.prismic.allHomepages.edges.slice(0, 1).pop();
  const home = props.data.prismic.allHomepages.edges[0];
  const data = home.node;
  const social = props.data.prismic.allSocials.edges.slice(0, 1).pop();

  if (!doc || !home) return null;


  function ScrollTo(event, num) {
    event.preventDefault();
    let item = document.getElementById('goto' + num)
    let path = item.offsetHeight + item.offsetTop;
    window.scroll({
      top: path,
      behavior: 'smooth'
    });
  };

  return (
    <Layout>
      <SEO
        title="Home"
        titleTemplate={social.node.default_title || "Leading Edge"}
        description={
          social.node.default_description ||
          "No copays, deductibles, prior authorizations, or pre-approvals. Welcome to Pharmacy Redefined."
        }
        image={"src/images/eScript.logo.png"}
        pathname="https://www.escript360.com/"
        siteLanguage="en-US"
        siteLocale="en_us"
        twitterUsername="@escript360"
      />

      <div className="homepage-hero" id="goto1">
        <div className="homepage-hero__inner">
          <div className="homepage-hero__content">
            <div className="homepage-hero__heading">
              {data.hero_heading[0].text}
            </div>
            <div className="homepage-hero__text">
              <RichText render={data.hero_subheading} />
            </div>

            {data.hero_button_text && (
              <div className="homepage-hero__cta">
                <button onClick={(e) => ScrollTo(e, 1)} className="button button--secondary">
                  {data.hero_button_text}
                </button>
              </div>
            )}
          </div>

          {data.hero_image && (
            <div className="homepage-hero__image-container">
              <img
                src={data.hero_image.url}
                alt=""
                className="homepage-hero__image"
              />

              <Fade right distance="4rem">
                <img
                  src={DotGridPurple}
                  alt=""
                  className="homepage-hero__dot-grid"
                />
              </Fade>
            </div>
          )}
        </div>
      </div>

      {/* elevator pitch */}
      <div className="elevator-pitch">
        <div className="elevator-pitch__inner">
          <div className="elevator-pitch__floaters">
            <Fade bottom distance="4rem">
              <div className="floater">
                <Pill fill="#00B4D7" />
              </div>
            </Fade>

            <Fade bottom distance="4rem">
              <div className="floater">
                <Pill fill="#00B4D7" />
              </div>
            </Fade>

            <Fade bottom distance="4rem">
              <div className="floater">
                <Pill fill="#00B4D7" />
              </div>
            </Fade>

            <Fade bottom distance="4rem">
              <div className="floater">
                <Pill fill="#00B4D7" className="circular" />
              </div>
            </Fade>

            <Fade bottom distance="4rem">
              <div className="floater">
                <Pill fill="#00B4D7" className="circular" />
              </div>
            </Fade>
          </div>

          <header className="elevator-pitch__header">
            <h2 className="elevator-pitch__heading">
              {data.revolution_heading[0].text}
            </h2>
            <div className="row_revolution">
              {
                data.revolution_bullet_1 && (
                  <p className="elevator-pitch__text">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 479.97 456.15">
                      <g id="Layer_x0020_1">
                        <path fill="#00b4d7" d="M32.94 165.7l0 -68.54c0,-16.47 13.4,-29.88 29.85,-29.88l277.37 0 28.23 -32.24c-3.05,-0.46 -6.22,-0.71 -9.42,-0.71l-296.18 0c-34.64,0 -62.8,28.18 -62.8,62.83l0 107.85 32.94 -39.31z"></path>
                        <path fill="#00b4d7" d="M388.86 180.74l0 212.58c0,16.47 -13.4,29.88 -29.89,29.88l-296.18 0c-16.45,0 -29.85,-13.4 -29.85,-29.88l0 -141.5 -32.94 -27.62 0 169.12c0,34.64 28.15,62.83 62.8,62.83l296.18 0c34.64,0 62.83,-28.18 62.83,-62.83l0 -250.21 -32.94 37.63z"></path>
                        <polygon fill="#00b4d7" points="13.75,214.24 64.11,154.14 192.09,261.42 420.99,0 479.97,51.65 200.55,370.82 "></polygon>
                      </g>
                    </svg>
                    Insurance obstacles
                  </p>
                )
              }
              {
                data.revolution_bullet_2 && (
                  <p className="elevator-pitch__text">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 479.97 456.15">
                      <g id="Layer_x0020_1">
                        <path fill="#00b4d7" d="M32.94 165.7l0 -68.54c0,-16.47 13.4,-29.88 29.85,-29.88l277.37 0 28.23 -32.24c-3.05,-0.46 -6.22,-0.71 -9.42,-0.71l-296.18 0c-34.64,0 -62.8,28.18 -62.8,62.83l0 107.85 32.94 -39.31z"></path>
                        <path fill="#00b4d7" d="M388.86 180.74l0 212.58c0,16.47 -13.4,29.88 -29.89,29.88l-296.18 0c-16.45,0 -29.85,-13.4 -29.85,-29.88l0 -141.5 -32.94 -27.62 0 169.12c0,34.64 28.15,62.83 62.8,62.83l296.18 0c34.64,0 62.83,-28.18 62.83,-62.83l0 -250.21 -32.94 37.63z"></path>
                        <polygon fill="#00b4d7" points="13.75,214.24 64.11,154.14 192.09,261.42 420.99,0 479.97,51.65 200.55,370.82 "></polygon>
                      </g>
                    </svg>
                    Financial barriers
                  </p>
                )
              }
              {
                data.revolution_bullet_3 && (
                  <p className="elevator-pitch__text">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 479.97 456.15">
                      <g id="Layer_x0020_1">
                        <path fill="#00b4d7" d="M32.94 165.7l0 -68.54c0,-16.47 13.4,-29.88 29.85,-29.88l277.37 0 28.23 -32.24c-3.05,-0.46 -6.22,-0.71 -9.42,-0.71l-296.18 0c-34.64,0 -62.8,28.18 -62.8,62.83l0 107.85 32.94 -39.31z"></path>
                        <path fill="#00b4d7" d="M388.86 180.74l0 212.58c0,16.47 -13.4,29.88 -29.89,29.88l-296.18 0c-16.45,0 -29.85,-13.4 -29.85,-29.88l0 -141.5 -32.94 -27.62 0 169.12c0,34.64 28.15,62.83 62.8,62.83l296.18 0c34.64,0 62.83,-28.18 62.83,-62.83l0 -250.21 -32.94 37.63z"></path>
                        <polygon fill="#00b4d7" points="13.75,214.24 64.11,154.14 192.09,261.42 420.99,0 479.97,51.65 200.55,370.82 "></polygon>
                      </g>
                    </svg>
                    Lapse of treatment
                  </p>
                )
              }
              {
                data.revolution_bullet_4 && (
                  <p className="elevator-pitch__text">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 479.97 456.15">
                      <g id="Layer_x0020_1">
                        <path fill="#00b4d7" d="M32.94 165.7l0 -68.54c0,-16.47 13.4,-29.88 29.85,-29.88l277.37 0 28.23 -32.24c-3.05,-0.46 -6.22,-0.71 -9.42,-0.71l-296.18 0c-34.64,0 -62.8,28.18 -62.8,62.83l0 107.85 32.94 -39.31z"></path>
                        <path fill="#00b4d7" d="M388.86 180.74l0 212.58c0,16.47 -13.4,29.88 -29.89,29.88l-296.18 0c-16.45,0 -29.85,-13.4 -29.85,-29.88l0 -141.5 -32.94 -27.62 0 169.12c0,34.64 28.15,62.83 62.8,62.83l296.18 0c34.64,0 62.83,-28.18 62.83,-62.83l0 -250.21 -32.94 37.63z"></path>
                        <polygon fill="#00b4d7" points="13.75,214.24 64.11,154.14 192.09,261.42 420.99,0 479.97,51.65 200.55,370.82 "></polygon>
                      </g>
                    </svg>
                    Adverse events
                  </p>
                )
              }
            </div>
          </header>
          <header className="elevator-pitch__header second_div">
            <h4 className="elevator-pitch__heading">
              We make it easy
            </h4>
          </header>
          <ul className="fact-list">
            {data.features.map((feature, index) => {
              return (
                <li key={index}>
                  <div className="fact-list__icon">
                    <div className="fact-list__image">
                      <img
                        src={feature.feature_image.url}
                        alt={feature.feature_heading[0].text}
                      />
                    </div>
                  </div>
                  <h3 className="fact-list__heading">
                    {feature.feature_heading[0].text}
                  </h3>
                  <div className="fact-list__text">
                    <RichText render={feature.feature_text} />
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      </div>

      {/* on the go */}
      <div className="on-the-go">
        <div className="on-the-go__flourish-lines">
          <img
            className="on-the-go__flourish-line--left"
            src={FlourishLineLeft}
            alt="Flourished lines"
          />
          <img
            className="on-the-go__flourish-line--right"
            src={FlourishLineRight}
            alt="On the go"
          />
        </div>
        <div className="on-the-go__inner">
          <div className="on-the-go__image">
            <img src={MobilePng} alt="On the go" />
          </div>
          <div className="on-the-go__content">
            <h2 className="on-the-go__heading">
              {data.on_the_go_heading[0].text}
            </h2>
            <div>
              <Link
                to={`/360-gateway`}
                className="button button--primary"
              >
                {data.benefits_button_text}
              </Link>
            </div>
          </div>

          <div className="on-the-go__floaters">
            <Fade bottom distance="4rem">
              <div className="floater">
                <Pill fill="#00B4D7" className="circular" />
              </div>
            </Fade>

            <Fade bottom distance="4rem">
              <div className="floater">
                <Pill fill="#00B4D7" />
              </div>
            </Fade>

            <Fade bottom distance="4rem">
              <div className="floater">
                <Pill fill="#00B4D7" className="circular" />
              </div>
            </Fade>
          </div>
        </div>
      </div>

      {/* medication ticker */}
      <div className="medication-ticker">
        <Carousel
          afterChange={(
            previousSlide,
            { currentSlide, onMove },
            nextSlide
          ) => { }}
          responsive={responsive}
          autoPlay={true}
          arrows={false}
          infinite={true}
          autoPlaySpeed={3000}
          stagePadding={100}
          focusOnSelect={true}
          swipeable={false}
          isActive={true}
          draggable={false}
          containerClass={"medication-ticker__ticker"}
        >
          {data.meds_list.map((med, index) => {
            return (
              <div key={index}>
                <span>{med.med_name[0].text}</span>
              </div>
            );
          })}
        </Carousel>

        <div className="medication-ticker__inner">
          <div className="medication-ticker__content">
            <img src={DotGrid} alt="" className="medication-ticker__dot-grid" />

            <h2 className="medication-ticker__heading">
              {data.med_slider_text[0].text}
            </h2>

            <div className="medication-ticker__button-container">
              <Link
                to={`/${data.med_slider_link._meta.uid}`}
                className="button button--primary"
              >
                {data.med_slider_button_text}
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* benefits */}
      <div className="everyone-benefits">
        <div className="everyone-benefits__inner">
          {/* text content */}
          <div className="everyone-benefits__content">
            <h2 className="everyone-benefits__heading">
              {data.benefits_heading[0].text}
            </h2>

            <div className="everyone-benefits__text">
              <RichText render={data.benefits_text} />
            </div>
            <span className="everyone-benefits__price">{data.pricing}</span>

            <div>
              <Link
                to={`/360-gateway`}
                className="button button--primary"
              >
                {data.benefits_button_text}
              </Link>
            </div>
          </div>

          {/* people */}
          <div className="everyone-benefits__collage">
            <img
              src={data.benefits_image_man_1.url}
              className="everyone-benefits__photo everyone-benefits__photo--1"
              alt=""
            />

            <img
              src={data.benefits_image_girl_with_dog.url}
              className="everyone-benefits__photo everyone-benefits__photo--2"
              alt=""
            />

            <img
              src={data.benefits_image_man_2.url}
              className="everyone-benefits__photo everyone-benefits__photo--3"
              alt=""
            />

            <img
              src={data.benefits_image_people_on_bike.url}
              className="everyone-benefits__photo everyone-benefits__photo--4"
              alt=""
            />

            <img
              src={linedFloater}
              className="everyone-benefits__lines"
              alt=""
            />

            <img
              src={wavyLines}
              className="everyone-benefits__wavy-lines"
              alt=""
            />

            {/* floaters */}
            <Fade bottom distance="2rem">
              <div className="floater floater--1">
                <Pill fill="#00B4D7" />
              </div>
            </Fade>

            <Fade bottom distance="2rem">
              <div className="floater floater--2">
                <Pill fill="#00B4D7" />
              </div>
            </Fade>
          </div>

          <div className="everyone-benefits__floaters">
            <Fade bottom distance="4rem">
              <div className="floater">
                <Pill fill="#00B4D7" />
              </div>
            </Fade>
          </div>
        </div>
      </div>

      {/* testimonials */}
      <div className="feature-testimonials">
        <Carousel
          responsive={responsive}
          containerClass={"feature-testimonials__slider"}
          autoPlay={false}
          arrows={true}
          infinite={true}
          draggable={false}
          autoPlaySpeed={8000}
        >
          {data.images.map((image, index) => {
            return (
              <div key={index}>
                <div className="feature-testimonials__item">
                  <div className="feature-testimonials__inner">
                    <div className="feature-testimonials__testimonial">
                      <p className="feature-testimonials__text">
                        {image.caption[0].text}
                      </p>

                      <img
                        src={arrowDown}
                        alt=""
                        className="feature-testimonials__arrow"
                      />
                    </div>

                    <div className="feature-testimonials__image">
                      <img src={image.image.url} alt={image.caption[0].text} />
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </Carousel>
      </div>

      {/* plans */}
      <div className="feature-plans">
        <div className="feature-plans__inner">
          <ul className="feature-plans__list">
            {data.plans_list.map((plan, index) => {
              return (
                <li key={index} className="feature-plans__plan">
                  <img
                    src={plan.image.url}
                    alt=""
                    className="feature-plans__image"
                  />

                  <h2 className="feature-plans__title">
                    {plan.plan_title[0].text}
                  </h2>
                </li>
              );
            })}
          </ul>

          <div className="feature-plans__content">
            <h2 className="feature-plans__heading">
              Healthcare can be hard, but we make it easy with <span>data-driven</span> insight into your brands performance
            </h2>

            <p className="feature-plans__text">{data.plan_text[0].text}</p>
            <span className="feature-plans__price">{data.pricing}</span>

            <Link to="/360-gateway" className="button button--primary">
              {data.plan_button_text}
            </Link>
          </div>
        </div>
      </div>

      {/* healthcare professionals */}
      <div className="roadblock roadblock--right">
        <div className="roadblock__inner">
          <div className="roadblock__floaters">
            <Fade bottom distance="4rem">
              <div className="floater">
                <Pill fill="#FFFFFF" />
              </div>
            </Fade>

            <Fade bottom distance="4rem">
              <div className="floater">
                <Pill fill="#FFFFFF" />
              </div>
            </Fade>

            <Fade bottom distance="4rem">
              <div className="floater">
                <Pill fill="#FFFFFF" />
              </div>
            </Fade>
          </div>

          <div className="roadblock__block roadblock__block--image">
            <img
              src={data.professionals_image.url}
              alt={data.professionals_heading[0].text}
            />
          </div>

          <div className="roadblock__block roadblock__block--content">
            <h2 className="roadblock__heading">
              {data.professionals_heading[0].text}
            </h2>

            <h6 className="subheading_roadblock">Say goodbye to mediocrity and hello to empowerment. Begin your journey by logging into the 360 Gateway.</h6>

            <div className="roadblock__text">
              <ul>
                <li>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 479.97 456.15">
                    <g id="Layer_x0020_1">
                      <path fill="#fff" d="M32.94 165.7l0 -68.54c0,-16.47 13.4,-29.88 29.85,-29.88l277.37 0 28.23 -32.24c-3.05,-0.46 -6.22,-0.71 -9.42,-0.71l-296.18 0c-34.64,0 -62.8,28.18 -62.8,62.83l0 107.85 32.94 -39.31z"></path>
                      <path fill="#fff" d="M388.86 180.74l0 212.58c0,16.47 -13.4,29.88 -29.89,29.88l-296.18 0c-16.45,0 -29.85,-13.4 -29.85,-29.88l0 -141.5 -32.94 -27.62 0 169.12c0,34.64 28.15,62.83 62.8,62.83l296.18 0c34.64,0 62.83,-28.18 62.83,-62.83l0 -250.21 -32.94 37.63z"></path>
                      <polygon fill="#fff" points="13.75,214.24 64.11,154.14 192.09,261.42 420.99,0 479.97,51.65 200.55,370.82 "></polygon>
                    </g>
                  </svg>Ensure that patients receive the medication prescribed</li>
                <li>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 479.97 456.15">
                    <g id="Layer_x0020_1">
                      <path fill="#fff" d="M32.94 165.7l0 -68.54c0,-16.47 13.4,-29.88 29.85,-29.88l277.37 0 28.23 -32.24c-3.05,-0.46 -6.22,-0.71 -9.42,-0.71l-296.18 0c-34.64,0 -62.8,28.18 -62.8,62.83l0 107.85 32.94 -39.31z"></path>
                      <path fill="#fff" d="M388.86 180.74l0 212.58c0,16.47 -13.4,29.88 -29.89,29.88l-296.18 0c-16.45,0 -29.85,-13.4 -29.85,-29.88l0 -141.5 -32.94 -27.62 0 169.12c0,34.64 28.15,62.83 62.8,62.83l296.18 0c34.64,0 62.83,-28.18 62.83,-62.83l0 -250.21 -32.94 37.63z"></path>
                      <polygon fill="#fff" points="13.75,214.24 64.11,154.14 192.09,261.42 420.99,0 479.97,51.65 200.55,370.82 "></polygon>
                    </g>
                  </svg>Monitor their therapeutic journey of care</li>
                <li>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 479.97 456.15">
                    <g id="Layer_x0020_1">
                      <path fill="#fff" d="M32.94 165.7l0 -68.54c0,-16.47 13.4,-29.88 29.85,-29.88l277.37 0 28.23 -32.24c-3.05,-0.46 -6.22,-0.71 -9.42,-0.71l-296.18 0c-34.64,0 -62.8,28.18 -62.8,62.83l0 107.85 32.94 -39.31z"></path>
                      <path fill="#fff" d="M388.86 180.74l0 212.58c0,16.47 -13.4,29.88 -29.89,29.88l-296.18 0c-16.45,0 -29.85,-13.4 -29.85,-29.88l0 -141.5 -32.94 -27.62 0 169.12c0,34.64 28.15,62.83 62.8,62.83l296.18 0c34.64,0 62.83,-28.18 62.83,-62.83l0 -250.21 -32.94 37.63z"></path>
                      <polygon fill="#fff" points="13.75,214.24 64.11,154.14 192.09,261.42 420.99,0 479.97,51.65 200.55,370.82 "></polygon>
                    </g>
                  </svg>Administer over medication management</li>
                <li>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 479.97 456.15">
                    <g id="Layer_x0020_1">
                      <path fill="#fff" d="M32.94 165.7l0 -68.54c0,-16.47 13.4,-29.88 29.85,-29.88l277.37 0 28.23 -32.24c-3.05,-0.46 -6.22,-0.71 -9.42,-0.71l-296.18 0c-34.64,0 -62.8,28.18 -62.8,62.83l0 107.85 32.94 -39.31z"></path>
                      <path fill="#fff" d="M388.86 180.74l0 212.58c0,16.47 -13.4,29.88 -29.89,29.88l-296.18 0c-16.45,0 -29.85,-13.4 -29.85,-29.88l0 -141.5 -32.94 -27.62 0 169.12c0,34.64 28.15,62.83 62.8,62.83l296.18 0c34.64,0 62.83,-28.18 62.83,-62.83l0 -250.21 -32.94 37.63z"></path>
                      <polygon fill="#fff" points="13.75,214.24 64.11,154.14 192.09,261.42 420.99,0 479.97,51.65 200.55,370.82 "></polygon>
                    </g>
                  </svg>Improve the value of medical care delivery</li>
              </ul>
            </div>

            <div className="roadblock__button">
              <Link
                to="/360-gateway"
                className="button button--secondary"
              >
                {data.professionals_button_text}
              </Link>
            </div>
          </div>
        </div>
      </div>
      {/* 
      <QAComponent
        buttonLink={data.faq_link}
        buttonText={data.faq_button_text}
        heading={data.faq_heading[0].text}
        data={data.faq_list || undefined}
        helpText={data.faq_help_text}
        dotGrid={DotGrid}
        passedStyle={false}
      /> */}
    </Layout>
  );
};

export default Index;

export const query = graphql`
  {
    site {
      siteMetadata {
        getStartedUrl
      }
    }
    prismic {
      allHomepages {
        edges {
          node {
            title
            text_block
            hero_image
            hero_heading
            hero_subheading
            hero_button_text
            revolution_bullet_1
            revolution_bullet_2
            revolution_bullet_3
            revolution_bullet_4
            revolution_heading
            features {
              feature_heading
              feature_image
              feature_text
            }
            how_it_works_heading
            benefits_button_text
            benefits_image
            benefits_heading
            benefits_image_girl_with_dog
            benefits_image_man_1
            benefits_image_man_2
            benefits_image_people_on_bike
            benefits_text
            med_slider_button_text
            med_slider_text
            on_the_go_heading
            on_the_go_image
            professionals_text
            professionals_image
            professionals_heading
            professionals_button_text
            pricing
            plan_text
            plan_heading
            plan_button_text
            benefits {
              heading
              image
              text
            }
            images {
              caption
              image
            }
            plans_list {
              image
              plan_title
            }
            meds_list {
              med_name
            }
            med_slider_link {
              ... on PRISMIC_Med_finder {
                _meta {
                  uid
                }
              }
            }
          }
        }
      }
      allSocials {
        edges {
          node {
            default_description
            default_image
            site_name
            default_title
          }
        }
      }
    }
  }
`;
